import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";
import LegacyRedirect from "./components/LegacyRedirect";
import ChatWidget from "./components/ChatWidget";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import Home from "./pages/Home";
import Features from "./pages/Features";
import Solutions from "./pages/Solutions";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Legal from "./pages/Legal";
import CaseStudies from "./pages/CaseStudies";
import CaseStudy from "./pages/CaseStudy";
import Partners from "./pages/Partners";
import FleetTelematics from "./pages/platform/FleetTelematics";
import LogisticsOrchestration from "./pages/platform/LogisticsOrchestration";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminPosts from "./pages/admin/AdminPosts";
import AdminPostEditor from "./pages/admin/AdminPostEditor";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminCaseStudies from "./pages/admin/AdminCaseStudies";
import AdminCaseStudyEditor from "./pages/admin/AdminCaseStudyEditor";
import AdminConversations from "./pages/admin/AdminConversations";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
};

const Shell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Navbar />}
      <main className="flex-1">
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/blog" replace />} />
            <Route path="blog" element={<AdminPosts />} />
            <Route path="blog/:id" element={<AdminPostEditor />} />
            <Route path="case-studies" element={<AdminCaseStudies />} />
            <Route path="case-studies/:id" element={<AdminCaseStudyEditor />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="conversations" element={<AdminConversations />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/platform/fleet-telematics" element={<FleetTelematics />} />
          <Route path="/platform/logistics-orchestration" element={<LogisticsOrchestration />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/case-studies/:slug" element={<CaseStudy />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="*" element={<LegacyRedirect />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppFloat />}
      {!isAdmin && <ChatWidget />}
      <Toaster position="bottom-center" richColors />
    </>
  );
};

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <HelmetProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
